import { fireExplosionEnumsSubCategoryEnum } from '@/gen/types/FireExplosionEnumsSubCategory';
import { yesNoOptionEnum } from '@/gen/types/YesNoOption';

import { whenPathEquals } from './conditions';
import type { IncidentFieldRule } from './types';

export const fireExplosionFieldRules: IncidentFieldRule[] = [
    {
        key: 'subCategory',
        label: 'What happened?',
        description: 'Select whether this was a fire, explosion, or both.',
        order: 90,
        options: [
            { value: fireExplosionEnumsSubCategoryEnum.Fire, label: 'Fire' },
            { value: fireExplosionEnumsSubCategoryEnum.Explosion, label: 'Explosion' },
            { value: fireExplosionEnumsSubCategoryEnum.CombinationOfAbove, label: 'Combination of above' },
            { value: fireExplosionEnumsSubCategoryEnum.Other, label: 'Other' },
        ],
    },
    {
        key: 'affectedArea',
        label: 'Which area was affected?',
        description: 'Describe the area impacted by the fire or explosion.',
        order: 100,
    },
    {
        key: 'fireServiceEmergencyResponders',
        label: 'Were emergency services involved?',
        description: 'Select Yes if emergency services were called or attended.',
        order: 110,
    },
    {
        key: 'alarmsActivated',
        label: 'Were any alarms activated?',
        description: 'Select Yes if any fire or smoke alarms were triggered.',
        order: 120,
    },
    {
        key: 'hazardousMaterialInvolved',
        label: 'Were hazardous materials involved?',
        description: 'Select Yes and describe if hazardous substances were involved.',
        order: 130,
    },
    {
        key: 'hazardousMaterialInvolvedExplanation',
        label: 'Hazardous material explanation',
        kind: 'textarea',
        order: 140,
        visibleWhen: whenPathEquals('hazardousMaterialInvolved', yesNoOptionEnum.Yes),
        requiredWhen: whenPathEquals('hazardousMaterialInvolved', yesNoOptionEnum.Yes),
    },
    {
        key: 'propertyEquipmentDamage',
        label: 'Was there any property damage?',
        description: 'Select Yes and describe if any equipment, buildings, or assets were damaged.',
        order: 160,
    },
    {
        key: 'propertyDamageExplanation',
        label: 'Property damage explanation',
        kind: 'textarea',
        order: 170,
        visibleWhen: whenPathEquals('propertyEquipmentDamage', yesNoOptionEnum.Yes),
        requiredWhen: whenPathEquals('propertyEquipmentDamage', yesNoOptionEnum.Yes),
    },
    {
        key: 'unplannedEmission',
        label: 'Did this cause unplanned CO2 emissions?',
        description: 'Select Yes if the fire or explosion caused unexpected CO2 emissions.',
        order: 180,
    },
    {
        key: 'environmentalExposure',
        label: 'Environmental exposure (if any)',
        description: 'Select any environmental media exposed, e.g. air, soil, water.',
        order: 150,
    },
];
